// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  SegmentPayload,
} from "./types";

export default {
  archetypeId: __t.string(),
  archetypeSeed: __t.u64(),
  generatorVersion: __t.string(),
  treeId: __t.u64(),
  regionName: __t.string(),
  positionX: __t.f64(),
  positionY: __t.f64(),
  positionZ: __t.f64(),
  rotationY: __t.f64(),
  get segments() {
    return __t.array(SegmentPayload);
  },
  correlationId: __t.string(),
};
